import type { PaginationParams, PaginationFilters } from "@rebuild/shared";

export const ESTIMATE_KEYS = {
  all: () => ["estimates"] as const,
  list: (params: PaginationParams & PaginationFilters) => [...ESTIMATE_KEYS.all(), "list", params] as const,
  detail: (estimateId: string) => [...ESTIMATE_KEYS.all(), "detail", estimateId] as const,
  detailMetadata: (estimateId: string) => [...ESTIMATE_KEYS.all(), "detailMetadata", estimateId] as const,
  xactimateMapping: (estimateId: string) => [...ESTIMATE_KEYS.all(), "xactimateMapping", estimateId] as const,
  xactimateMappingByTemplate: (estimateId: string, templateLineItemId: string) =>
    [...ESTIMATE_KEYS.all(), "xactimateMapping", estimateId, "template", templateLineItemId] as const,
};
